/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, ElementRef, InjectionToken} from '@angular/core';
import {IfOpenService} from '../../utils/conditional/if-open.service';
import {POPOVER_HOST_ANCHOR} from '../common/popover-host-anchor.token';
export class Tooltip {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-tooltip",
    template: `
        <ng-content></ng-content>
    `,
    host: {
        "[class.tooltip]": "true",
    },
    providers: [IfOpenService, {provide: POPOVER_HOST_ANCHOR, useExisting: ElementRef}]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Tooltip_tsickle_Closure_declarations() {
/** @type {?} */
Tooltip.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Tooltip.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
